import { AfterViewChecked, Component, DoCheck, ElementRef, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'odd-errors',
    templateUrl: './error.component.html',
    styleUrls: [ './error.component.scss' ],
})

export class ErrorComponent implements AfterViewChecked {
    @Input() public readonly name: string;
    @Input() public readonly when: string | string[] = 'dirty';

    constructor(
        private readonly el: ElementRef,
    ) {}

    public ngAfterViewChecked(): void {
        const elements = this.el.nativeElement.querySelectorAll('small:not([hidden])');

        if (elements.length) {
            for (const element of elements) {
                element.classList.add('hidden');
            }

            const el = elements[0];

            el.classList.remove('hidden');
        }
    }
}
